// Copyright (c) 2016 Deere & Company

import './pip-link.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const PipLink = ({id, pipLinkStyle = 'pip-link', pipLinkText}) => {

    const pipLinkPath = `/pips/programs/${id}`;

    return (
        <Link
            className={pipLinkStyle}
            to={pipLinkPath}
        >
            <FormattedMessage id={pipLinkText}/>
        </Link>
    );

};

PipLink.displayName = 'PipLink';
PipLink.propTypes = {
    id: PropTypes.string,
    pipLinkStyle: PropTypes.string,
    pipLinkText: PropTypes.string.isRequired
};

export default PipLink;



// WEBPACK FOOTER //
// ./src/pip/shared/components/pip-link.js